import { formatIsoDate as formatDate } from './formatDate';

export function deriveDateRangeForPeriod(period) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  if (period === 'monthly') {
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return { startDate: formatDate(start), endDate: formatDate(end) };
  }

  if (period === 'quarterly') {
    const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
    const start = new Date(today.getFullYear(), quarterStartMonth, 1);
    const end = new Date(today.getFullYear(), quarterStartMonth + 3, 0);
    return { startDate: formatDate(start), endDate: formatDate(end) };
  }

  if (period === 'yearly') {
    const start = new Date(today.getFullYear(), 0, 1);
    const end = new Date(today.getFullYear(), 11, 31);
    return { startDate: formatDate(start), endDate: formatDate(end) };
  }

  const currentDay = today.getDay() || 7;
  const start = new Date(today);
  start.setDate(today.getDate() - currentDay + 1);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  return { startDate: formatDate(start), endDate: formatDate(end) };
}
